import React, { useState } from 'react';

const HotelForm = ({ onSave, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    propertyName: initialData?.propertyName || '',
    location: initialData?.location || '',
    checkInDate: initialData?.checkInDate || '',
    checkInTime: initialData?.checkInTime || '',
    checkOutDate: initialData?.checkOutDate || '',
    checkOutTime: initialData?.checkOutTime || '',
    roomType: initialData?.roomType || '',
    confirmationNumber: initialData?.confirmationNumber || '',
    phoneNumber: initialData?.phoneNumber || '',
    description: initialData?.description || '',
    price: initialData?.price || ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      price: parseFloat(formData.price) || 0
    });
  };

  return (
    <form onSubmit={handleSubmit} className="component-form hotel-form">
      <div className="form-section">
        <h4>Hotel Information</h4>
        
        <div className="form-group">
          <label>Title/Description*</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({...formData, title: e.target.value})}
            placeholder="e.g., 3 Nights at Hilton Paris"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Property Name*</label>
            <input
              type="text"
              value={formData.propertyName}
              onChange={(e) => setFormData({...formData, propertyName: e.target.value})}
              placeholder="e.g., Hilton Paris Opera"
              required
            />
          </div>
          <div className="form-group">
            <label>Location*</label>
            <input
              type="text"
              value={formData.location}
              onChange={(e) => setFormData({...formData, location: e.target.value})}
              placeholder="e.g., Paris, France"
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Check-in Date*</label>
            <input
              type="date"
              value={formData.checkInDate}
              onChange={(e) => setFormData({...formData, checkInDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Check-out Date*</label>
            <input
              type="date"
              value={formData.checkOutDate}
              onChange={(e) => setFormData({...formData, checkOutDate: e.target.value})}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Room Type</label>
            <input
              type="text"
              value={formData.roomType}
              onChange={(e) => setFormData({...formData, roomType: e.target.value})}
              placeholder="e.g., Deluxe King Room"
            />
          </div>
          <div className="form-group">
            <label>Price*</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({...formData, price: e.target.value})}
              placeholder="0.00"
              min="0"
              step="0.01"
              required
            />
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Update' : 'Add'} Hotel
        </button>
      </div>
    </form>
  );
};

export default HotelForm;
